// extracted by mini-css-extract-plugin
export var contained = "aHbFSok5vpYpzZR4P_Tx";
export var focusVisible = "rEZNmmVv6aM39hpisD7X";
export var large = "w12nWsKwsw57vXwrQG2J";
export var root = "dfnM5RKLwMkpcqyWIEUY";
export var small = "WEvQpuYoahZ_YGHA5FGV";